export default __webpack_public_path__ + "static/media/Yoast-logo-without-mission.51fc6cf0.svg";